import * as yup from "yup";

export const loginSchema = yup.object().shape({
    email: yup.string().required("Email obrigatório").email("Email inválido"),
    password: yup.string().required("Senha obrigatória")
});

export const registerSchema = yup.object().shape({
    name: yup.string().required("Nome obrigatório"),
    email: yup.string().required("Email obrigatório").email("Email inválido"),
    password: yup.string().required("Senha obrigatória")
        .matches(/(?=.*?[A-Z])/,"Sua senha deve ter pelo menos uma letra maiúscula")
        .matches(/(?=.*?[a-z])/,"Sua senha deve tero pelo menos uma letra minússcula")
        .matches(/(?=.*?[0-9])/,"Sua senha deve conter pelo menos um número")
        .min(6,"Sua senha deve conter pelo menos 6 caracteres"),
    passwordConf: yup.string().required("Confirmação de senha obrigatória")
        .oneOf([yup.ref('password'), null], 'Confirmação incorreta'),
    contact: yup.string().required("Contato obrigatório"),
    bio: yup.string().required("Bio obrigatória").min(10,"Sua bio deve ter no mínimo 10 caracteres"),
    course_module: yup.string().required("Módulo obrigatório")
        .oneOf([
            "Primeiro módulo(Introdução ao Frontend)",
            "Segundo módulo (Frontend Avançado)",
            "Terceiro módulo (Introdução ao Backend)",
            "Quarto módulo (Backend Avançado)"
        ],"Módulo obrigatório")
});


export const newTechSchema = yup.object().shape({
    title: yup.string().required("Título obrigatório"),
    status: yup.string().required("Status obrigatório")
        .oneOf(["Iniciante","Intermediário","Avançado"],"Status obrigatório")
})